/* PreNumbers Critical Finance — Investment & Equity modal (reskinned).

   Shared by Critical Finance and PSBB (via contextToUse / usedAt). Logic is
   unchanged; only the markup is reskinned to .pn-*. Wrapped in .pn-modal-embed
   so the accent aliases resolve even when antd portals the modal to body. */

import { useState, useContext } from 'react';

import { CriticalFinancePageContext } from '../CriticalFiancePage.jsx';

import { industryDetails, investmentEquityRenderFields, PSBBinvestmentEquityRenderFields } from '../../constants.jsx';
import { genericPOSTDatabaseCall } from '../../helperFunctions.jsx';
import { renderFbField, FbIcons } from '../../FinancialBuilder/fbUI.jsx';

const { SaveOutlined } = FbIcons;

async function saveEntityToDatabase(entity, usedAt) {
  return genericPOSTDatabaseCall(`/api/${usedAt}/saveEntity`, { entity }, 'entity info');
}

function InvestmentEquityModal({ contextToUse, usedAt = 'cfi' }) {
  // Use the provided context or default to CriticalFinancePageContext
  const { entitySelected, messageApi, setEntitySelected } = useContext(contextToUse || CriticalFinancePageContext);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    messageApi.loading('Saving entity info...', 0);
    try {
      await saveEntityToDatabase({ ...entitySelected, id: entitySelected.cfi_id !== undefined ? entitySelected.cfi_id : entitySelected.id }, usedAt);
      messageApi.destroy();
      messageApi.success('Company info saved successfully');
    } catch (error) {
      console.error('Error saving entity info:', error);
      messageApi.destroy();
      messageApi.error('Failed to save entity info');
    }
    setSaving(false);
  };

  const handleInputChange = (event, entity, key) => {
    let newValue = event.target.value;
    setEntitySelected(prev => ({ ...prev, [key]: newValue }));
  };

  const handleInputBlur = (event, entity, key, field) => {
    let newValue = event.target.value;
    if (field.regexCondition && field.errorMessage && !field.regexCondition.test(newValue)) {
      messageApi.error(field.errorMessage);
      newValue = industryDetails[entity.industry][key] || field.default || '';
    }
    if (newValue === '') {
      messageApi.error('This field cannot be empty');
      newValue = industryDetails[entity.industry][key] || field.default || '';
    }
    setEntitySelected(prev => ({ ...prev, [key]: newValue }));
  };

  const fieldsToUse = usedAt === 'cfi' ? investmentEquityRenderFields : PSBBinvestmentEquityRenderFields;

  return (
    <div className="pn-modal-embed">
      <div className="pn-fieldset">
        <div className="pn-fieldset-title">Investment &amp; Equity Pricing</div>
        <div className="pn-fields">
          {fieldsToUse.map(field => renderFbField(field, entitySelected, handleInputChange, true, handleInputBlur))}
        </div>
      </div>
      <div className="pn-editor-foot">
        <div className="sp" />
        <button disabled={saving} onClick={handleSave} type="button" className="pn-btn pn-btn-accent"><SaveOutlined /> Save</button>
      </div>
    </div>
  );
}

export default InvestmentEquityModal;
